/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { Filter as FilterIcon } from '@opengeoweb/theme';
import { useSharedTranslation } from '../../utils/i18n';
import { CustomIconButton } from '../CustomIconButton';

export const FilterToggleButton: React.FC<{
  isOpen: boolean;
  onToggle: () => void;
  activeLabelFilterCount: number;
}> = ({ isOpen, onToggle, activeLabelFilterCount }) => {
  const { t } = useSharedTranslation();

  const tooltipTitle = isOpen
    ? (t('shared-filter-hide-labels') ?? '')
    : (t('shared-filter-show-labels') ?? '');

  return (
    <Tooltip title={tooltipTitle}>
      <CustomIconButton
        aria-pressed={isOpen}
        data-testid="workspace-label-filter-toggle"
        id="labels-filter"
        isSelected={isOpen || activeLabelFilterCount > 0}
        onClick={onToggle}
        sx={{
          '&.MuiIconButton-root': {
            padding: activeLabelFilterCount > 0 ? '0px 22px' : '0px 4px',
          },
          display: 'flex',
          alignItems: 'center',
        }}
        variant="tool"
      >
        <FilterIcon />
        {activeLabelFilterCount > 0 && (
          <Typography component="span" sx={{ fontSize: '13px', pr: 0.1 }}>
            {activeLabelFilterCount}
          </Typography>
        )}
      </CustomIconButton>
    </Tooltip>
  );
};
